import React from 'react';
import _ from 'lodash';
import { Grid, Button } from 'semantic-ui-react';

const FooterLinks = ({ onClickHandler, options }) => {
  return _.map(options, (option, index) => (
    <Grid.Column key={index} width={4} className="text-end strong">
      <Button
        primary={!option.color}
        color={option.color || null}
        disabled={option.isDisabled}
        onClick={() => {
          onClickHandler && onClickHandler(option);
        }}
      >
        {option.type}
      </Button>
    </Grid.Column>
  ));
};

export default FooterLinks;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/FooterLinks.js